module.exports = __webpack_public_path__ + "img/nostromo 4 bagno.5f15a591.jpeg";